/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_SuccessInputs */

const en_settings_billing_cancel_success = /** @type {(inputs: Settings_Billing_Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription canceled`)
};

/**
* | output |
* | --- |
* | "Subscription canceled" |
*
* @param {Settings_Billing_Cancel_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_success = /** @type {((inputs?: Settings_Billing_Cancel_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_success(inputs)
});
export { settings_billing_cancel_success as "settings.billing.cancel_success" }